<template>
  <div id="editPwdDialog">
    <el-form :model="form"
             :rules="rules"
             ref="form"
             label-width="100px">
      <el-form-item label="用户编号::"
                    prop="fUsrNo">
        <el-input v-model="form.fUsrNo"
                  autocomplete="off"
                  :disabled="isDisabled"></el-input>
      </el-form-item>
      <el-form-item label="用户姓名::"
                    prop="fUsrName">
        <el-input v-model="form.fUsrName"
                  autocomplete="off"
                  :disabled="isDisabled"></el-input>
      </el-form-item>
      <el-form-item label="原密码::"
                    prop="fUsrPwdOld">
        <el-input type="password"
                  v-model="form.fUsrPwdOld"
                  autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="新密码::"
                    prop="fUsrPwd">
        <el-input type="password"
                  v-model="form.fUsrPwd"
                  autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="确认密码::"
                    prop="checkPass">
        <el-input type="password"
                  v-model="form.checkPass"
                  autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer"
         class="dialog-footer"
         style="text-align:right">
      <el-button type="primary"
                 @click="submitForm('form')">保存</el-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as api from '@/api/user'
export default {
  name: 'editPwd',
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.fUsrPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var validatePwd = (rule, value, callback) => {
      if (this.isLoginValidate) {
        if (!((value || '').length >= 8 && (value || '').length <= 30)) {
          callback(new Error('长度为8到30个字符'))
        }
        if (
          !/^([a-zA-Z]+[0-9]+[!@#$%^&*]+)|([a-zA-Z]+[!@#$%^&*]+[0-9]+)|([0-9]+[!@#$%^&*]+[a-zA-Z]+)|([0-9]+[a-zA-Z]+[!@#$%^&*]+)|([!@#$%^&*]+[a-zA-Z]+[0-9]+)|([!@#$%^&*]+[0-9]+[a-zA-Z]+)$/.test(
            value
          )
        ) {
          callback(new Error('密码必须要包含字母、数字和特殊符号'))
        }
      } else {
        if (!((value || '').length >= 6 && (value || '').length <= 30)) {
          callback(new Error('长度为6到30个字符'))
        }
      }
      callback()
    }
    return {
      isLoginValidate: false,
      formLabelWidth: '120px',
      isDisabled: true,
      rules: {
        fUsrPwdOld: [
          { required: true, message: '请输入用户密码', trigger: 'blur' },
          { min: 6, max: 30, message: '长度为8到30个字符', trigger: 'blur' }
        ],
        fUsrPwd: [
          { required: true, message: '请输入用户密码', trigger: 'blur' },
          { validator: validatePwd, trigger: 'blur' }
        ],
        checkPass: [
          { required: true, message: '请再次输入用户密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    form: Object
  },
  methods: {
    ...mapActions(['getCurrentUser', 'editCurrentUserPwd']),
    clearForm () {
      this.$refs.form.resetFields()
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.editCurrentUserPwd(this.form).then(res => {
            if (res && res.data) {
              let { status, data } = res
              if (status !== 200) {
                this.$message({
                  type: 'error',
                  message: '用户操作出错'
                })
              } else {
                if (!data.IsOk) {
                  this.$message({
                    type: 'error',
                    message: data.Msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '修改密码成功'
                  })
                  this.$emit('editpwdcallback')
                }
              }
            }
          })
        }
      })
    }
  },
  created () {
    api.initConfig().then(res => {
      let { data } = res
      if (data.IsOk) {
        this.isLoginValidate = data.Data.validate
      }
    })
  },
  mounted () { }
}
</script>
<style>
#editPwdDialog .el-button {
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 10px;
  padding-bottom: 10px;
}
#editPwdDialog .el-input__inner {
  height: 32px;
  line-height: 32px;
}
#editPwdDialog .el-input__inner {
  height: 32px;
  line-height: 32px;
}
#editPwdDialog .el-form-item__content {
  line-height: 32px;
  position: relative;
  font-size: 14px;
}
#editPwdDialog .el-form-item__label {
  text-align: right;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 32px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
#editPwdDialog .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#editPwdDialog .el-dialog__title {
  color: white;
}
#editPwdDialog .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#editPwdDialog .el-dialog__body {
  padding: 5px;
}

#editPwdDialog .myEditPwdLableClass {
  text-align: right;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 30px;
}
#editPwdDialog .myParkInput input.el-input__inner {
  line-height: 30px !important;
  height: 30px !important;
  color: #666666;
}
#editPwdDialog .el-radio {
  line-height: 2px;
}
</style>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/editPwd.vue